import { clamp, randomInt } from "./utils";
import { Color, createHsl, getRGB, Hex, HSL, isHex, parseHsl } from "../types/color.model";

export const randomHex = (): Hex => {
    const red = randomInt(256);
    const green = randomInt(256);
    const blue = randomInt(256);

    const redHex = red.toString(16).padStart(2, '0');
    const greenHex = green.toString(16).padStart(2, '0');
    const blueHex = blue.toString(16).padStart(2, '0');
    return `#${redHex}${greenHex}${blueHex}`;
};

export const shiftHexColorValue = (color: Hex, amt: number): Hex => {
    const num = parseInt(color.substring(1), 16);
    const r = (num >> 16) & 0xff;
    const g = (num >> 8) & 0xff;
    const b = num & 0xff;
    // clamp shifted values to 0-255
    const newR = clamp(r + amt, 0, 255);
    const newG = clamp(g + amt, 0, 255);
    const newB = clamp(b + amt, 0, 255);
    // reconstruct hex color
    const newColor = (newR << 16) | (newG << 8) | newB;
    return `#${newColor.toString(16).padStart(6, '0')}`;
};

export const shiftColorValue = (color: Color, amt: number): Color => {
    if (isHex(color)) {
        return shiftHexColorValue(color, amt);
    } else {
        return color;
    }
};

export const addHslVariation = (hsl: HSL, options: { hue?: number; sat?: number; light?: number } = {}): HSL => {
    const { h, s, l } = parseHsl(hsl);
    const hueVar = options.hue || 8;
    const satVar = options.sat || 12;
    const lightVar = options.light || 10;
  
    const newH = (h + (Math.random() - 0.5) * 2 * hueVar + 360) % 360;
    const newS = Math.max(10, Math.min(90, s + (Math.random() - 0.5) * 2 * satVar));
    const newL = Math.max(15, Math.min(85, l + (Math.random() - 0.5) * 2 * lightVar));
  
    return createHsl(newH, newS, newL);
};

export const generateBaseHsl = (): HSL => {
    const h = Math.random() * 360;
    const s = 60 + Math.random() * 30; // 60-90% saturation for vibrant colors
    const l = 40 + Math.random() * 35; // 40-75% lightness for good contrast
    return createHsl(h, s, l);
};

export const normalizeHue = (hue: number): number => ((hue % 360) + 360) % 360;

export const overlayIconColor = (backgroundColor: Color): Color => {
    // simple luminance check - could use more sophisticated method
    const rgb = getRGB(backgroundColor);
    const luminance = (0.299 * rgb.red + 0.587 * rgb.blue + 0.114 * rgb.blue) / 255;
    return luminance > 0.5 ? '#000000' : '#FFFFFF';
};
